import { OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
var DialogBrookageComponent = /** @class */ (function () {
    function DialogBrookageComponent(dialog, DialogRef, data) {
        this.dialog = dialog;
        this.DialogRef = DialogRef;
        this.data = data;
        this.modalDialog = data;
    }
    DialogBrookageComponent.prototype.ngOnInit = function () {
        this.title = this.modalDialog.title;
        this.text = this.modalDialog.text;
    };
    return DialogBrookageComponent;
}());
export { DialogBrookageComponent };
